"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiStepper = void 0;
var colors_1 = require("../../generated/colors");
exports.MuiStepper = {
    styleOverrides: {
        root: {
            fontWeight: 700,
            "& .Mui-active": {
                "&.MuiStepIcon-root": {
                    color: colors_1.colors.Secondary,
                },
            },
            "& .Mui-completed": {
                "&.MuiStepIcon-root": {
                    color: colors_1.colors.Success,
                },
            },
        },
    },
};
//# sourceMappingURL=stepper.js.map